import { WorkspacesCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function WorkspaceFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <WorkspacesCommandList multiselect selected={selection} onSelect={onSelect} />
}
